import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { ExternalCPCDto, MceApiService } from '../../../core/mceapi.client.generated';
import { Option, match, none, some, } from '../../../shared/functions/functional';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { rxResource } from '@angular/core/rxjs-interop';
import { SelectedCable } from '../selection/cable-selection.model';

export const CPCConductors = [
  { value:'Aluminium', label:'Aluminium'},
  {value:'Bronze', label:'Bronze'},
  {value:'Copper', label:'Copper'},
  {value:'Cuponal', label:'Cuponal'},
  {value:'Lead', label:'Lead'},
  {value:'StainlessSteel', label:'Stainless Steel'},
  {value:'Steel', label:'Steel' }]

export interface ExternalCPC {
  hasCPC: boolean,
  conductor: string,
  csa: number
}

export function buildExternalCPCSchema(_: ExternalCPC) { }

export function createExternalCPC(externalCpc: Option<ExternalCPCDto>) {
  return signal<ExternalCPC>(
    match(
      () => ({ hasCPC: false, conductor: 'Copper', csa: 16.0 }),
      (x: ExternalCPCDto) => {
        if (x.conductor === undefined || x.csa === undefined) {
          throw new Error('External CPC DTO is missing required values.');
        }

        return { hasCPC: true, conductor: x.conductor, csa: x.csa };
      })
    (externalCpc) );
}

export function createExternalCPCDto(model: FieldTree<ExternalCPC>) {
  return signal<Option<ExternalCPCDto>>(
    model.hasCPC().value() === false
      ? none
      : some({
        conductor: model.conductor().value(),
        csa: model.csa().value(),
      }));
  }


@Component({
  selector: 'app-external-cpc',
  imports: [FormField,MatCheckboxModule, MatSelectModule],
  templateUrl: './external-cpc.component.html',
  styles: ``,
})
export class ExternalCpcComponent {

  readonly form = input.required<FieldTree<ExternalCPC>>();
  readonly selectedCable = input.required<FieldTree<SelectedCable>>();

  private readonly mceApiService = inject(MceApiService);

  cpcConductors = signal(CPCConductors);

  csasRx = rxResource({
    params: () => ({}),
    stream: () => this.mceApiService.v1EarthingCpcCsaPreferred()
  });
  csas = computed(() => {
    const csa = this.csasRx.value();
    return csa === undefined ? [] : csa;
  });

}
